import { ContextFormByIdProvider, IContextFormByIdBeforeMount } from "@ngt/forms";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router-dom";
import { FormDefinitions } from "../../api/dtos";

export interface IAssetFormByIdRouteProps extends PropsWithChildren {
    assetId?: number | undefined;

    loadBeforeMount?: boolean | IContextFormByIdBeforeMount;
    validateBeforeMount?: boolean | IContextFormByIdBeforeMount;
}

const AssetFormByIdRoute: FC<IAssetFormByIdRouteProps> = ({
    assetId,
    loadBeforeMount,
    validateBeforeMount,
    children
}) => {
    const params = useParams();

    const assetIdToUse = (params.assetId ? +params.assetId : undefined) ?? assetId ?? undefined;

    return (
        <ContextFormByIdProvider
            formId={assetIdToUse}
            formDefinitionIdentifier={FormDefinitions.Asset}

            loadBeforeMount={loadBeforeMount}
            //LoadingComponent={RouteLoading}

            validateBeforeMount={validateBeforeMount}
            //ValidatingComponent={RouteLoading}
        >
            {children}
        </ContextFormByIdProvider>
    );
}

export default AssetFormByIdRoute;
